import { useRestPostQuery, RestQueryHookOptions } from 'utils/hooks/api';
import { CampaignLevelMetrics } from 'modules/messagingInsights/types';

type QueryCampaignMetricsParams = {
  startTime: string;
  endTime: string;
  campaignIds: number[];
  metrics: {
    mediumMetrics: { name: string }[];
    overallMetrics: { name: string }[];
  };
};

export type QueryCampaignMetricsResponse = {
  campaignLevelMetrics: CampaignLevelMetrics;
};

export const QUERY_CAMPAIGN_METRICS_API_URL = '/analytics/metrics/campaigns';

export const useQueryCampaignMetrics = (
  params: QueryCampaignMetricsParams,
  options?: RestQueryHookOptions<QueryCampaignMetricsResponse>,
) => {
  const { data, isLoading, isError, error } = useRestPostQuery(
    QUERY_CAMPAIGN_METRICS_API_URL,
    params,
    options,
  );

  return {
    goalMetrics: data,
    isLoading,
    isError,
    error,
  };
};
